(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4820],{

/***/ 21706:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_error",
      function () {
        return __webpack_require__(55942);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 55942:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _error; }
});

// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-769137b2ab/0/cache/next-npm-12.2.3-07d597c2b7-b13b42fbb3.zip/node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(1861);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ./src/styles/index.ts
var styles = __webpack_require__(52655);
// EXTERNAL MODULE: ./src/ui/ContentsButton/index.ts + 1 modules
var ContentsButton = __webpack_require__(27689);
// EXTERNAL MODULE: ./src/ui/Image/index.ts
var Image = __webpack_require__(71267);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(67748);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@design-system-pc-virtual-9891e7a910/0/cache/@design-system-pc-npm-4.8.2-12a77acac1-f2e19fad33.zip/node_modules/@design-system/pc/dist/design-system-pc.js
var design_system_pc = __webpack_require__(39894);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-769137b2ab/0/cache/next-npm-12.2.3-07d597c2b7-b13b42fbb3.zip/node_modules/next/link.js
var next_link = __webpack_require__(49344);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-769137b2ab/0/cache/next-npm-12.2.3-07d597c2b7-b13b42fbb3.zip/node_modules/next/router.js
var next_router = __webpack_require__(71975);
// EXTERNAL MODULE: ../../.yarn/unplugged/styled-components-virtual-24edae5a63/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10278);
;// CONCATENATED MODULE: ./src/feat-components/error/ErrorLayout.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100vw;\n  height: 100vh;\n  flex-direction: column;\n  align-items: center;\n  padding-top: 160px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: 120px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: 24px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  margin-bottom: 40px;\n  ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  white-space: pre-wrap;\n  text-align: center;\n  color: ",
        ";\n  margin-bottom: 80px;\n  ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  max-width: 570px;\n  align-items: center;\n  flex-direction: column;\n  width: 100%;\n  gap: 8px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}










var ErrorLayout = function(props) {
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ErrorContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoIconBox, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc.CI, {
                    variant: "CI_symbol_primary",
                    resize: true,
                    width: 121,
                    height: 30
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BangIconBox, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: (0,utils/* getAsset */.Nh)("/assets/icons/ic_empty_72.svg"),
                    width: "72px",
                    height: "72px",
                    alt: "errorBangIcon"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorTitle, {
                children: props.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorText, {
                dangerouslySetInnerHTML: {
                    __html: props.text
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BtnLayout, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentsButton/* default */.Z, {
                            size: "bold",
                            emphasis: "high",
                            width: "100%",
                            children: "한샘몰 메인"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentsButton/* default */.Z, {
                        size: "bold",
                        emphasis: "low",
                        width: "100%",
                        onClick: function() {
                            return router.back();
                        },
                        children: "이전 페이지"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var error_ErrorLayout = (ErrorLayout);
var ErrorContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ErrorLayout__ErrorContainer",
    componentId: "sc-81af6f96-0"
})(_templateObject());
var LogoIconBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ErrorLayout__LogoIconBox",
    componentId: "sc-81af6f96-1"
})(_templateObject1());
var BangIconBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ErrorLayout__BangIconBox",
    componentId: "sc-81af6f96-2"
})(_templateObject2());
var ErrorTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ErrorLayout__ErrorTitle",
    componentId: "sc-81af6f96-3"
})(_templateObject3(), styles/* theme.colors.accent_colors.primary.default */.rS.colors.accent_colors.primary["default"], styles/* theme.typography.subtitle2 */.rS.typography.subtitle2);
var ErrorText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ErrorLayout__ErrorText",
    componentId: "sc-81af6f96-4"
})(_templateObject4(), styles/* theme.colors.neutral_colors.gray.700 */.rS.colors.neutral_colors.gray[700], styles/* theme.typography.body1 */.rS.typography.body1);
var BtnLayout = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ErrorLayout__BtnLayout",
    componentId: "sc-81af6f96-5"
})(_templateObject5());

;// CONCATENATED MODULE: ./src/feat-components/error/NotFound.tsx



var NotFound = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorLayout, {
        title: "페이지를 찾을 수 없습니다.",
        text: "요청하신 주소가 잘못되었거나<br/> 변경 또는 삭제되었을 수 있습니다.<br/> 주소를 다시 한번 확인 부탁드립니다."
    });
};
/* harmony default export */ var error_NotFound = (NotFound);

;// CONCATENATED MODULE: ./src/feat-components/error/index.tsx


// EXTERNAL MODULE: ./src/feat-components/error/Unavailable.tsx
var Unavailable = __webpack_require__(55704);
;// CONCATENATED MODULE: ./src/feat-components/error/UnusualApproach.tsx



var UnusualApproach = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_ErrorLayout, {
        title: "정상적인 접근이 아닙니다.",
        text: "이용에 불편을 드려 죄송합니다.<br/> 더 좋은 서비스 제공을 위해 최선을 다하겠습니다.<br/> 감사합니다. "
    });
};
/* harmony default export */ var error_UnusualApproach = (UnusualApproach);

// EXTERNAL MODULE: ../../.yarn/__virtual__/@sentry-nextjs-virtual-13176860ba/0/cache/@sentry-nextjs-npm-7.45.0-506dcd4824-201e7392db.zip/node_modules/@sentry/nextjs/esm/index.client.js + 101 modules
var index_client = __webpack_require__(27592);
;// CONCATENATED MODULE: ./pages/_error.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}







var RootError = function(param) {
    var statusCode = param.statusCode;
    if (statusCode === 404) return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_NotFound, {});
    else if (statusCode === 500) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Unavailable/* default */.Z, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(error_UnusualApproach, {});
};
RootError.getInitialProps = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(param) {
        var res, err, statusCode;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    res = param.res, err = param.err;
                    _ctx.next = 3;
                    return index_client/* captureUnderscoreErrorException */.ud({
                        res: res,
                        err: err
                    });
                case 3:
                    statusCode = res ? res.statusCode : err ? err.statusCode : 404;
                    return _ctx.abrupt("return", {
                        statusCode: statusCode
                    });
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var _error = (RootError);


/***/ }),

/***/ 55704:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91987);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71975);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _design_system_pc__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39894);
/* harmony import */ var remodeling_web_mobile_sdk_ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41520);
/* harmony import */ var _services_tracking__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19676);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var Unavailable = function(param) {
    var isPageError = param.isPageError, _hasRefresh = param.hasRefresh, hasRefresh = _hasRefresh === void 0 ? true : _hasRefresh, _hasPrevious = param.hasPrevious, hasPrevious = _hasPrevious === void 0 ? true : _hasPrevious;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var handleRefresh = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        router.reload();
        isPageError && router.back();
    }, [
        isPageError,
        router
    ]);
    var handleBack = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        router.back();
    }, [
        router
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(remodeling_web_mobile_sdk_ui__WEBPACK_IMPORTED_MODULE_4__/* .VStack */ .gC, _objectSpreadProps(_objectSpread({
        width: "100%",
        padding: "0 16px"
    }, _services_tracking__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tagGTM */ .Z.tagGTM("unavailable")), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_design_system_pc__WEBPACK_IMPORTED_MODULE_3__.CI, {
                variant: "CI_symbol_primary",
                resize: true,
                width: 121,
                height: 60,
                mt: 67
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(remodeling_web_mobile_sdk_ui__WEBPACK_IMPORTED_MODULE_4__/* .VStack */ .gC, {
                space: 12,
                mt: "76px",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(remodeling_web_mobile_sdk_ui__WEBPACK_IMPORTED_MODULE_4__/* .Icongraphy */ .Jb, {
                        variant: "ic_empty_56"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(remodeling_web_mobile_sdk_ui__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
                        as: "p",
                        variant: "subTitle2",
                        color: (0,remodeling_web_mobile_sdk_ui__WEBPACK_IMPORTED_MODULE_4__/* .pickColor */ .ft)("accent_color.primary.default"),
                        textAlign: "center",
                        children: "서비스에 접속할 수 없습니다."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(remodeling_web_mobile_sdk_ui__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
                        as: "p",
                        variant: "body3",
                        color: (0,remodeling_web_mobile_sdk_ui__WEBPACK_IMPORTED_MODULE_4__/* .pickColor */ .ft)("natural_color.gray.600"),
                        textAlign: "center",
                        children: [
                            "이용에 불편을 드려 죄송합니다.",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                            " 잠시 후 다시 이용 부탁드립니다."
                        ]
                    })
                ]
            }),
            (hasRefresh || hasPrevious) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(remodeling_web_mobile_sdk_ui__WEBPACK_IMPORTED_MODULE_4__/* .VStack */ .gC, {
                mt: "40px",
                space: 8,
                width: "100%",
                children: [
                    hasRefresh && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(remodeling_web_mobile_sdk_ui__WEBPACK_IMPORTED_MODULE_4__/* .BasicButton */ .kD, _objectSpreadProps(_objectSpread({
                        size: "lg",
                        emphasis: "medium",
                        width: "100%",
                        onClick: function() {
                            return handleRefresh();
                        }
                    }, _services_tracking__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tagGTM */ .Z.tagGTM("unavailable_refresh_button")), {
                        children: "새로 고침"
                    })),
                    hasPrevious && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(remodeling_web_mobile_sdk_ui__WEBPACK_IMPORTED_MODULE_4__/* .BasicButton */ .kD, _objectSpreadProps(_objectSpread({
                        size: "lg",
                        emphasis: "medium",
                        width: "100%",
                        onClick: function() {
                            return handleBack();
                        }
                    }, _services_tracking__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tagGTM */ .Z.tagGTM("unavailable_go_previous_button")), {
                        children: "이전 페이지"
                    }))
                ]
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Unavailable);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9344,9774,2888,179], function() { return __webpack_exec__(21706); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);